/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class MeevoLabel {
     restrict = "E";
     scope = {
       contentKey: "@"
     };
     template = "<label class=\"meevo-label\" translate=\"{{::contentKey}}\"></label>";
   
     static factory(): angular.IDirectiveFactory  {
       let directive = () => {
         return new MeevoLabel();
      };

      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoLabel", MeevoLabel.factory());
}